import { ref } from 'vue'

// 模块级单例：全应用共享一个音乐授权弹窗实例（对齐 useVersionCheck 的全局弹窗模式）
const visible = ref(false)

/** 弹出音乐授权弹窗（网易云未绑定，接口 code 2901 时调用） */
const openMusicAuth = () => {
  visible.value = true
}

/** 关闭音乐授权弹窗 */
const closeMusicAuth = () => {
  visible.value = false
}

/**
 * 网易云未绑定（接口返回 code 2901）统一授权弹窗。
 * 2901 分发集中在 unwrapData（useApi.ts）—— 命中即调 openMusicAuth，
 * 故各业务调用方无需自行判 2901。本 composable 仅供 MusicAuthDialog 组件绑定 visible/close。
 */
export function useMusicAuthDialog() {
  return { visible, open: openMusicAuth, close: closeMusicAuth }
}

export { openMusicAuth }
